/**
 * Ticket LM11: Suchmaschinen- und Teilen-Angaben einer Freebie-Landingpage.
 *
 * Als eigene Funktion, damit die Zusicherungen (Ersatzwerte für Titel und
 * Beschreibung, Vorschaubild als Teilen-Bild, kein Platzhalter ohne Bild) am
 * Verhalten geprüft werden können und nicht am Quelltext der Route.
 */

import { shareImageMeta, type ShareMetaEntry } from "@/lib/share-image-meta";

export type LeadMagnetMetaSource = {
  title: string;
  subtitle?: string;
  seoTitle?: string;
  seoDescription?: string;
  previewImageUrl?: string | null;
};

export function leadMagnetSeoTitle(magnet: LeadMagnetMetaSource): string {
  const own = (magnet.seoTitle ?? "").trim();
  return own || `${magnet.title} | kostenlos von creategy`;
}

export function leadMagnetSeoDescription(magnet: LeadMagnetMetaSource): string {
  const own = (magnet.seoDescription ?? "").trim();
  if (own) return own;
  const subtitle = (magnet.subtitle ?? "").trim();
  if (subtitle) return subtitle;
  return `${magnet.title}: kostenlose Unterlage von creategy für politische Kommunikation.`;
}

export type HeadMetaEntry = { title: string } | ShareMetaEntry;

export function leadMagnetHeadMeta(magnet: LeadMagnetMetaSource): HeadMetaEntry[] {
  const title = leadMagnetSeoTitle(magnet);
  const description = leadMagnetSeoDescription(magnet);
  return [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    ...shareImageMeta(magnet.previewImageUrl),
  ];
}
